import React, { useContext } from "react"
import { ValidateButton } from "../../../../../../../components/buttons/ValidateButton/ValidateButton"
import { CreateVariantDialogContext } from "../../BSVariantFormDialog/CreateVariantDialogContext"

export function BSVariantCreateButton(): React.JSX.Element {
  const { handleOpen } = useContext(CreateVariantDialogContext)

  return <ValidateButton label="Ajouter une estimation" onClick={handleOpen} />
}
